"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_USER_INFO_FAILURE = exports.UPDATE_USER_INFO_SUCCESS = exports.UPDATE_USER_INFO_REQUEST = exports.TOGGLE_SEARCH_DROPDOWN = exports.SEARCH_USERS_SUCCESS = exports.SEARCH_USERS_FAILURE = exports.SET_SEARCH_STRING = void 0;
exports.SET_SEARCH_STRING = '@sok/users/SET_SEARCH_STRING';
exports.SEARCH_USERS_FAILURE = '@sok/users/SEARCH_USERS_FAILURE';
exports.SEARCH_USERS_SUCCESS = '@sok/users/SEARCH_USERS_SUCCESS';
exports.TOGGLE_SEARCH_DROPDOWN = '@sok/users/TOGGLE_SEARCH_DROPDOWN';
exports.UPDATE_USER_INFO_REQUEST = '@sok/users/UPDATE_USER_INFO_REQUEST';
exports.UPDATE_USER_INFO_SUCCESS = '@sok/users/UPDATE_USER_INFO_SUCCESS';
exports.UPDATE_USER_INFO_FAILURE = '@sok/users/UPDATE_USER_INFO_FAILURE';
//# sourceMappingURL=users.js.map